import { Asset } from "lib/types";
import { createContext, useContext, ReactNode } from "react";

type DndAssetContextValue = {
  opacity: number;
  isSelected: boolean;
  isDragging: boolean;
  path: string;
  asset: Asset<any>;
}

const DndAssetContext = createContext(null);

export const DnDAssetProvider = ({ value, children }: {
  value: DndAssetContextValue, children: ReactNode
}) => {
  return <DndAssetContext.Provider value={value}>{children}</DndAssetContext.Provider>
};

export const useDndAsset = () => useContext(DndAssetContext);
